"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBestProvider = exports.fetchJson = exports.getTokenDecimals = exports.getTokenBalance = exports.getETHBalance = void 0;
const ethers_1 = require("ethers");
const __1 = require("..");
const getETHBalance = async (provider, address) => {
    return provider.getBalance(address);
};
exports.getETHBalance = getETHBalance;
const getTokenBalance = async (assetId, address, provider) => {
    return new ethers_1.Contract(assetId, __1.ERC20Abi, provider).balanceOf(address);
};
exports.getTokenBalance = getTokenBalance;
const getTokenDecimals = async (assetId, provider) => {
    return new ethers_1.Contract(assetId, __1.ERC20Abi, provider).decimals();
};
exports.getTokenDecimals = getTokenDecimals;
exports.fetchJson = ethers_1.utils.fetchJson;
/**
 * Gets the best RPC URL between several options by comparing latencies
 * @param rpcUrls - The source list
 * @returns - The best RPC URL
 */
const getBestProvider = async (rpcUrls) => {
    let bestProvider = undefined;
    let bestLatency = Infinity;
    for (const url of rpcUrls) {
        const provider = new ethers_1.providers.JsonRpcProvider(url);
        try {
            const start = Date.now();
            await provider.getBlockNumber();
            const latency = Date.now() - start;
            if (latency < bestLatency) {
                bestProvider = url;
                bestLatency = latency;
            }
        }
        catch (error) {
            console.log(`Error connecting to provider at ${url}: ${error}`);
        }
    }
    return bestProvider;
};
exports.getBestProvider = getBestProvider;
//# sourceMappingURL=shared.js.map